<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 0px;">

        <el-tabs type="border-card" :before-leave='beforeLeave' v-model="activeName">

          <el-tab-pane v-for="(item,i) in tableData" :key="i" :label="item.name">
            <component :is="item.currentRole" ref="componentSos"/>
          </el-tab-pane>

        </el-tabs>

      </div>
    </div>

  </div>
</template>

<script>

import XinLvPage from "./XinLvPage";
import SleepQualityPage from "./SleepInfoYJ";
import SleepAlarm from "./SleepAlarm";


export default {
  name: "SBJData",
  data() {
    return {

      userCode: '',
      activeName:'0',
      tableData: [
        {name: '心率数据',currentRole:'XinLvPage',isNone:true},
        {name: '睡眠报告',currentRole:'SleepQualityPage',isNone:false},
        {name: '睡眠报警',currentRole:'SleepAlarm',isNone:false},
      ],
    }
  },
  components: {
    XinLvPage,SleepQualityPage,SleepAlarm
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.activeName='0'
      this.tableData.forEach((item)=>{
        item.isNone=false
      })
      this.tableData[0].isNone=true
      this.$nextTick(() => {
        this.$refs.componentSos[0].init(userCode)
      })
    },
    closeSelf() {
      this.$emit("closeSBJData");
    },
    beforeLeave(activeName){

      this.$refs.componentSos[parseInt(activeName)].init(this.userCode)

    }
  },

}


</script>

<style lang="scss" scoped>

.modal-SOSSet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px;
      z-index: 99;
      height:500px;
      /deep/.el-tabs--border-card {
        box-shadow:none;
        .el-tabs__content{
          padding: 3px;
        }
      }
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>
